import React from "react";
import "./../../styles/businessnavbar.scss";

function PurchaseNavBar(){
    return(
        <div className ="main-header">
            <a className ="menu-link-main" href="#">All Apps</a>
            <div className ="header-menu">
                <a className ="main-header-link is-active" href="#">Summary</a>
                <a className ="main-header-link" href="#">Suppliers</a>
                <a className ="main-header-link" href="#">Global Market</a>
            </div>
        </div>
    );
}

export {PurchaseNavBar};